import React, { useState, useEffect } from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import DispatcherService from '../../services/DispatcherService'

import View from '../form/View'
import Checkbox from '../form/Checkbox'
import Header from '../form/Header'
import Footer from '../form/Footer'
import Loader from '../form/Loader'

const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'column',
    flex: 1,
    flexGrow: 1,
    minHeight: 0,
    overflowX: 'hidden'
  },
  content: {
    flex: 1,
    flexGrow: 1,
    overflowY: 'auto',
    margin: '0 36px',
    flexDirection: 'column',
  },
  loader: {
    justifyContent: 'center'
  },
  checkbox: {
    justifyContent: 'center',
    margin: '32px 0',
    overflowX: 'hidden'
  },
  documentTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '16px',
    fontSize: '28px',
    '@media(max-height: 976px)': {
      fontSize: '20px',
    },
  },
  documentContent: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    fontSize: '24px',
    '@media(max-height: 976px)': {
      fontSize: '16px',
    },
  }
}))

function DocumentStep (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ document, setDocument ] = useState(null)
  const [ parts, setParts ] = useState(null)
  const [ accepted, setAcceptance ] = useState(props.initialData && props.initialData.documentId)

  useEffect(() => {
    const loadDocument = async () => {
      const document = await DispatcherService.loadDocument(props.documentId)
      setParts(document.content.split('\n'))
      setDocument(document)
    }
    loadDocument()
  }, [setParts]);

  return (
    <View className={styles.root}>
      <Header
        title={props.msg}
        index={props.index}
        numOfSteps={props.numOfSteps}
        showMarkers={true}
      />
      { !document ? <>
        <View className={`${styles.content} ${styles.loader}`}>
          <Loader message='Carregando o documento'/>
        </View>
      </> : <>
        <View className={styles.content}>
          <p className={styles.documentTitle}>{document.title}</p>
          <p>
          { parts.map((part, index) => (
              <div key={index} className={styles.documentContent}><br/>{part}</div>
          ))}
            { document.externalContent && (<p className={styles.documentContent}>Clique <a className={styles.documentContent} href={document.externalContent} target='blank'>aqui</a> para mais informações.</p>)}

          </p>

        </View>
      </>}
      <View className={styles.checkbox}>
        <Checkbox
          label="Li e aceito os termos"
          checked={accepted}
          disabled={!document}
          onChange={value => setAcceptance(value)}
        />
      </View>

      <Footer
        onBack={() => props.back()}
        onNext={() => props.next({ documentId: props.documentId })}
        disabled={!accepted}
      />
    </View>
  )
}

export default DocumentStep